export default class Polling {
  start(init, request, time, callDuringStart = true) {
    init();
    this.request = request;
    this.intervalTime = time;
    this.setUpInterval();

    if (callDuringStart) {
      this.request();
    }
  }

  setUpInterval() {
    clearInterval(this.interval);
    this.interval = setInterval(this.request, this.intervalTime);
  }

  call() {
    this.setUpInterval();
    this.request();
  }

  stop = () => {
    clearInterval(this.interval);
  };
}
